import React from 'react';
import styles from 'components/ui/icons/DraftIcon.module.css';

type DraftIconProps = {
  title: string;
};

const DraftIcon = (props: DraftIconProps) => {
  return <span title={props.title} className={styles.draft}></span>;
};

export default DraftIcon;
